<template>
  <div>
    <div class="home">
      <van-nav-bar title="合作伙伴" left-text="返回" @click-left="onClickLeft" fixed/>
      <div class="navheight"></div>
      <div class="content">
        <div class="nongmu_cont">
          <div class="contentTie">
            <img src="../../assets/joinusimg/companylogo/zhengda.png" alt="">
            <div class="company">正大集团山东区</div>
          </div>
          <div class="labInfo">
            <span>生猪</span>
            <span>养殖</span>
            <span>食品</span>
            <span>担保</span>
          </div>
          <div class="companyInfo">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/zhengdajituanshandongqu@3x.png" alt="">
            <div class="companyWord">正大集团是泰籍华人创办的知名跨国企业，在中国以外称作卜蜂集团。正大集团是一家以农牧食品、商业零售、电信三大事业为核心，同时涉足金融、地产、制药、机械加工等10 多个行业领域的多元化跨国集团公司，业务遍及100多个国家和地区，员工超过35万人，2017年集团销售总额超过550亿美元。正大集团农牧企业山东区目前有七家公司，其中饲料公司三家，分别为济南正大、青岛正大农业及城阳分公司，饲料销售业务遍及山东省内各地；养殖公司三家，分别为山东正大畜禽、青岛正大猪业及胶南分公司，养殖场主要分布在潍坊、青岛、济南、聊城等地；即墨正大投资担保公司一家。未来几年，正大山东区将重点围绕山东区200万头生猪项目，加快推进产业化发展，逐步形成集饲料—育种—养殖—食品深加工—品牌/市场于一体的产业化发展体系。</div>
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/zhengdajituanshandongqu1@3x.png" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/zhengdajituanshandongqu2@3x.png" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/zhengdajituanshandongqu3@3x.png" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/zhengdajituanshandongqu4@3x.png" alt="">
          </div>
        </div>
      </div>
      <div class='bottom'>
        <div class="title">经营范围</div>
          <div class="info"> 禽畜饲养；粮食收购；配合饲料（畜禽、水产、幼畜禽、种畜禽）；浓缩饲料（畜禽、水产、幼畜禽、种畜禽）；精料补充料（反刍）；兽药制剂（不包括生物制品）批发（动物防疫合格证,粮食收购许可证,生产企业审查合格证，兽药经营许可证 有效期限以许可证为准）。水产饲养，上述产品及其原料的批发和农副产品批发；预混料销售；佣金代理（拍卖除外）业务及相关的技术服务，货物进出口业务（不含进口商品的分销业务）。</div>
      </div>
      <footer class="nongmu-footer">
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/wangzhi@3x.png" alt=""></dt>
          <dd><a href="http://www.cpgroup.cn">http://www.cpgroup.cn</a></dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt>
          <dd>青岛胶州阜安第二工业园正大路</dd>
        </dl>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partner',
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/style/partner.scss';
</style>
